<script setup lang="ts">
import type { Message } from '@/composables/toast';

import { isShown, markAsShown } from '../model';
import { DEFAULT_MESSAGE } from '../config';

const { message = DEFAULT_MESSAGE } = defineProps<{ message?: Message }>();

const { addWarningToast } = useToast();

onMounted(() => {
  if (isShown()) {
    return;
  }

  addWarningToast(message, { duration: Infinity });
  markAsShown();
});
</script>
<template>
  <slot />
</template>
